<template>
  <div class="root">
    <div class="container">
      <div class="container-inner">
        <div class="title">Importing Remaining Orders</div>
        <div class="progress-bar-wrapper">
          <ProgressBar :height="'4px'" :indicatorColor="'#00f0bf'" :progress="progressPercent" :progressBarColor="'#676767'" />
        </div>
        <span class="tooltip-wrapper">
          <ToolTip darkIcon />
          <SvgIconHelp />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import SvgIconHelp from '@/svgs/SvgIconHelp'

  import ProgressBar from '@/components/ProgressBar'
  import ToolTip from '@/components/ToolTip'

  export default {
    name: 'BaseOrderLoadingIndicator',
    components: {
      ProgressBar,
      SvgIconHelp,
      ToolTip
    },
    props: {
      progressPercent: String,
      title: String
    }
  }
</script>

<style lang="scss" scoped>
@import '../../scss/abstracts/__dir';
@import '../../scss/global/__dir';

.container {
  background: rgba(0,0,0,0.84);
  border-radius: 4px;
  color: $white;
  display: inline-block;
  font-family: $font-primary-bold;
  font-size: 14px;
  line-height: 1.2;
  padding: 14px 21px 16px 15px;
  user-select: none;
  max-width: calc(100vw - 32px);
  width: 251px;
}

.container-inner {
  position: relative;
}

.progress-bar-wrapper {
  margin-top: 11px;
}

.root {
  bottom: 24px;
  left: 16px;
  position: fixed;
  z-index: 600;
}

.tooltip-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  transform: translate3d(calc(80% + 2px), -50%, 0);
}
</style>



// WEBPACK FOOTER //
// src/js/components/BaseOrdersLoadingIndicator.vue